import { gql } from '@apollo/client';

// export const APP_SETTINGS = gql`
//   query appSettings {
//     appSettings {
//       id
//       type
//       values {
//         key
//         value
//         type
//       }
//     }
//   }
// `;

export const APP_SETTINGS = gql`
  query appSettings(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    appSettings(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      appSettings {
        id
        type
        values {
          key
          value
          type
        }
      }
    }
  }
`;

export const UPDATE_APP_SETTINGS = gql`
  mutation updateAppSetting(
    $id: ID!
    $type: SettingType!
    $value: [KeyValueInput]!
  ) {
    updateAppSetting(id: $id, type: $type, value: $value)
  }
`;

export const GET_ALL_TRADER_TAGS = gql`
  query getAllTraderTags {
    getAllTraderTags {
      id
      tagName
      colorCode
      isDeleted
    }
  }
`;

export const CREATE_TRADER_TAG = gql`
  mutation CreateTraderTag($input: TraderTagInputDTO!) {
    createTraderTag(traderTagInputDTO: $input)
  }
`;

export const UPDATE_TRADER_TAG = gql`
  mutation updateTraderTag($input: UpdateTraderTagInputDTO!) {
    updateTraderTag(updateTraderTagInputDTO: $input)
  }
`;

export const DELETE_TRADER_TAG = gql`
  mutation deleteTraderTag($traderTagId: ID!) {
    deleteTraderTag(traderTagId: $traderTagId)
  }
`;
